export default "__VITE_ASSET__Fvhtv5_v__"